// src/components/SplashScreen.jsx
import React, { useEffect, useState } from 'react';
import './SplashScreen.css';
import ELogo from './ELogo';

const SplashScreen = ({ onComplete }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => setIsExiting(true), 2500);
    const completeTimer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 3000);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`splash-screen ${isExiting ? 'splash-screen-exit' : ''}`}>
      <div className="splash-content">
        <div className="splash-logo-container">
          <ELogo size="xlarge" className="e-logo--splash" />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
